import axios from 'axios';

const baseURL = process.env.CONTENT_ENGINE_URL;
const contextBaseUrl = `${baseURL}/app/contexts`;

const context = {
    // GET /app/contexts
    async getContext() {
        return axios.get(`${contextBaseUrl}`);
    },

    // PUT /app/contexts/keys/{key}
    async updateContextItem(key, details) {
        return axios.put(`${contextBaseUrl}/keys/${key}`, details);
    },
};

export default context;



// WEBPACK FOOTER //
// ./src/api/context.js